module.exports = {
    "createImage": "/api/cps/createImage", //制作镜像
};



// WEBPACK FOOTER //
// ./src/api/privateInstance/list/config.js